'use client';

import clsx from 'clsx';
import { Children, FC, PropsWithChildren, ReactNode, useRef, useState } from 'react';
import { FilterItemServerProps, SHOW_FILTERS } from './types';
import useAccordion from '@/hooks/useAccordion';
import FilledLeftArrow from '@/components/Icon/FilledLeftArrow';

import styles from './FilterItemServer.module.css';

const FilterItemServer: FC<PropsWithChildren<FilterItemServerProps>> = ({ children, filterTitle, hideAccordion }) => {
  const [showAllFilters, setShowAllFilters] = useState(false);
  const filterContent = useRef<HTMLDivElement>(null);
  const { height, handleAccordionOpen, isShortListOpened } = useAccordion({
    shortListRef: filterContent,
    isOpened: true,
    duration: 300,
  });
  const childrenArray = Children.toArray(children);
  const filtersCheckbox: Array<ReactNode> =
    childrenArray.length > SHOW_FILTERS && !showAllFilters ? childrenArray.slice(0, SHOW_FILTERS) : [...childrenArray];

  return (
    <div className={clsx(styles.filterItem, { [styles.filterItemFirst]: hideAccordion })}>
      {!hideAccordion && (
        <b className={styles.filterAccordionTitle} onClick={handleAccordionOpen}>
          {filterTitle}
          <FilledLeftArrow width="10" height="10" className={clsx({ [styles.arrowOpen]: isShortListOpened.current })} />
        </b>
      )}
      <div
        ref={filterContent}
        data-testid={'filter-items-accordion'}
        style={{ height: height }}
        className={clsx(styles.filterItemContent, { [styles.filterItemContentFirst]: hideAccordion })}
      >
        {filtersCheckbox}
        {childrenArray.length > SHOW_FILTERS && !showAllFilters && (
          <p
            data-testid={'filter-item-show-more-btn'}
            onClick={() => setShowAllFilters(true)}
            className={clsx(styles.showMoreButton, { [styles.loading]: true })}
          >
            {'(+)'}
            <span className={styles.moreText}>{`Show ${childrenArray.length - SHOW_FILTERS} more`}</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default FilterItemServer;
